module.exports = require('./getOnyxIsEmbedded')
